<template>
  <div>
      <o-form-group v-if="memberTitle" title="Member" class="text-start mb-2">
          <span class="text-danger"> *</span>
          <template v-if="$props.code">
              <o-input-text v-model="$props.member_name" :disabled="true"/>
              <input type="hidden" v-model="$props.member_id"/>
          </template>
          <template v-else>
              <o-lookup-member v-model="localMemberId" :member-name="member_name" :inject-member="injectMember"/>
          </template>
      </o-form-group>
      <o-form-group v-else :label="false" class="text-start">
          <template v-if="$props.code">
              <o-input-text v-model="$props.member_name" :disabled="true"/>
              <input type="hidden" v-model="$props.member_id"/>
          </template>
          <template v-else>
              <o-lookup-member v-model="localMemberId" :member-name="member_name" :inject-member="injectMember"/>
          </template>
      </o-form-group>
  </div>
</template>
  
<script>
  import { OLookupMember, OFormGroup, OInputText } from '@/components/OmnihControl';
  
  export default {
    name: 'OMemberDetail',
    components: {
      OFormGroup,
      OLookupMember,
      OInputText
    },
    props: {
      members: {
        type: Array,
        required: true
      },
      member_name: {
        type: String,
        default: ''
      },
      member_id: {
        type: String,
        default: ''
      },
      code: {
        type: String,
        default: ''
      },
      memberTitle: {
        type: Boolean,
        default: true
      },
        injectMember: { // Tambahkan properti baru
            type: Boolean,
            default: false
        }
    },
    data() {
      return {
        localMemberId: this.member_id || ''
      };
    },
    watch: {
      member_id: {
        immediate: true,
        handler(newVal) {
          this.localMemberId = newVal;
        }
      },
      localMemberId(newVal) {      
        this.$emit('update:member_id', newVal);
      }
    }
  };
</script>